import { render, staticRenderFns } from "./DirectMailrRevenueSearch.vue?vue&type=template&id=0b4fcab1&"
import script from "./DirectMailrRevenueSearch.vue?vue&type=script&lang=js&"
export * from "./DirectMailrRevenueSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports